module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_BG-f87d57d862a685e34b98f7ffabe1a21c.svg";